import { getDeductionMethodMap } from '../localeConstants';
import { PolicyState, PolicyStatus } from '../shared/generated';
export var policyIsRenewPolicy = function policyIsRenewPolicy(info) {
  return [PolicyStatus.POLICY_RENEWED, PolicyStatus.POLICY_RENEWED_INITIATED, PolicyStatus.POLICY_RENEWED_UPDATE_REFERRAL, PolicyStatus.POLICY_RENEWED_UPDATE_SUBMITTED, PolicyStatus.POLICY_RENEWED_UPDATE_QUOTE, PolicyStatus.POLICY_RENEWED_UPDATE_VOID].includes(info === null || info === void 0 ? void 0 : info.status);
};
export var policyIsCurrentActiveRenewPolicy = function policyIsCurrentActiveRenewPolicy(info) {
  return [PolicyStatus.POLICY_RENEWED, PolicyStatus.POLICY_RENEWED_INITIATED, PolicyStatus.POLICY_RENEWED_UPDATE_REFERRAL, PolicyStatus.POLICY_RENEWED_UPDATE_SUBMITTED, PolicyStatus.POLICY_RENEWED_UPDATE_QUOTE].includes(info === null || info === void 0 ? void 0 : info.status);
};
export var canCancelRenewalPolicy = function canCancelRenewalPolicy(info) {
  var _ref = info || {},
      renewalCancelled = _ref.renewalCancelled,
      state = _ref.state;

  return [PolicyState.POLICY_ACTIVE].includes(state) && (policyIsRenewPolicy(info) || !policyIsRenewPolicy(info) && !renewalCancelled);
};
export var canCancelPolicy = function canCancelPolicy(info) {
  var _ref2 = info || {},
      status = _ref2.status,
      state = _ref2.state;

  return [PolicyState.POLICY_ACTIVE].includes(state) && ![PolicyStatus.POLICY_CANCELLED, PolicyStatus.POLICY_CANCEL_INITIATED, PolicyStatus.POLICY_CANCEL_CONFIRMED].includes(status) && !policyIsRenewPolicy(info);
};
export var canShowPolicyEstimatedCancellationDate = function canShowPolicyEstimatedCancellationDate(info) {
  var _ref3 = info || {},
      status = _ref3.status;

  return [PolicyStatus.POLICY_CANCEL_INITIATED, PolicyStatus.POLICY_CANCEL_CONFIRMED].includes(status);
};
export var canShowPolicyRealCancellationDate = function canShowPolicyRealCancellationDate(info) {
  var _ref4 = info || {},
      cancellationDate = _ref4.cancellationDate,
      status = _ref4.status;

  return [PolicyStatus.POLICY_CANCELLED].includes(status) && !!cancellationDate;
};
export var policyHaveUnconfirmedPaymentInfo = function policyHaveUnconfirmedPaymentInfo(info) {
  var _ref5 = info || {},
      status = _ref5.status,
      quotePayload = _ref5.quotePayload;

  return [PolicyStatus.POLICY_UPDATE_QUOTE, PolicyStatus.POLICY_UPDATE_REFERRAL].includes(status) && (quotePayload === null || quotePayload === void 0 ? void 0 : quotePayload.billingCycle) === getDeductionMethodMap().annual.value;
};
export var canSaveRecordPolicy = function canSaveRecordPolicy(policyInfo) {
  var _ref6 = policyInfo || {},
      status = _ref6.status;

  return [PolicyStatus.POLICY_UPDATE_INITIATED, PolicyStatus.POLICY_UPDATE_QUOTE, PolicyStatus.POLICY_UPDATE_REFERRAL, PolicyStatus.POLICY_RENEWED_INITIATED, PolicyStatus.POLICY_RENEWED_UPDATE_QUOTE, PolicyStatus.POLICY_RENEWED_UPDATE_REFERRAL].includes(status);
};
export var policyIsCancellation = function policyIsCancellation(policyInfo) {
  var _ref7 = policyInfo || {},
      status = _ref7.status;

  return [PolicyStatus.POLICY_CANCELLED, PolicyStatus.POLICY_CANCEL_CONFIRMED, PolicyStatus.POLICY_CANCEL_INITIATED].includes(status);
};
export var policyIsCancelled = function policyIsCancelled(policyInfo) {
  var _ref8 = policyInfo || {},
      status = _ref8.status;

  return [PolicyStatus.POLICY_CANCELLED].includes(status);
};
export var policyIsUnActiveUsed = function policyIsUnActiveUsed(info) {
  return [PolicyStatus.POLICY_UPDATE_QUOTE_VOID, PolicyStatus.POLICY_RENEWED_UPDATE_VOID, PolicyStatus.POLICY_ELAPSED, PolicyStatus.POLICY_CANCELLED, PolicyStatus.POLICY_CANCEL_INITIATED, PolicyStatus.POLICY_CANCEL_CONFIRMED].includes(info === null || info === void 0 ? void 0 : info.status);
};